import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-124" data-mp="2z3gzu1uhcxfw">
      <div className="mx-auto max-w-3xl" data-id="element-125" data-mp="3mtbfssa3j24d">
        <SectionHeading title={<span id="faq-title" data-id="element-127" data-mp="3rs5v3k8uu8jq">Frequently asked questions</span>} data-id="element-126" data-mp="3rrwdajxyr7p4" />

        <div className="mt-10 divide-y divide-sand border-y border-sand" data-id="element-128" data-mp="3rtqt5judo9mc">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-129" data-mp="3i09x096rqifi" data-mpi={i}>
                <h3 data-id="element-130" data-mp="9m9ope2p7z8k">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[17px] font-bold text-ink hover:text-brand" data-id="element-131" data-mp="9lrm7zpg0os7">
                    {faq.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-132" data-mp="1vpj1nf6yf7l1" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-133" data-mp="2jfdazms2ee0j">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-134" data-mp="2ehbt356dkkqn">
                      <p className="pb-5 text-[16px] leading-relaxed text-ink/80" data-id="element-135" data-mp="u2jo7d5oxccx">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-136" data-mp="1nssfl0eetzci">
          <CTAButton label="I’m ready — give me access" data-id="element-137" data-mp="1nu3kj3jldd57" />
        </div>
      </div>
    </section>;
}